<template>
    <div :class="['c-flex__item', flexClass]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        width: {
            type: String,
            default: 'fluid',
            validator(value) {
                return [
                    'fluid',
                    'content',
                    'auto'
                ].includes(value);
            } 
        }
    },
    computed: {
        flexClass() {
            return this.width === 'content'
                ? 'flex-none'
                : this.width === 'auto'
                    ? 'flex-auto'
                    : 'flex-1';
        }
    }
};
</script>